import { useEffect, useMemo } from 'react';
import { Writing, Publications, ContactCTA } from '@ui/sections';
import { publications } from '@content/publications';
import { site } from '@content/site';
import { writingCopy, publicationsCopy, contactCtaCopy } from '@content/ui-strings';
import { useGhostPosts } from '@lib/hooks/useGhostPosts';
import type { Post } from '@lib/schemas/post';

export function WritingRoute() {
  useEffect(() => {
    document.title = `Writing · ${site.seo.title.split(' · ')[0] ?? 'Alison Haire'}`;
  }, []);

  const { data: ghostPosts, loading } = useGhostPosts(6);

  const blogPosts: ReadonlyArray<Post> = ghostPosts ?? [];

  const externalPosts: ReadonlyArray<Post> = useMemo(
    () =>
      publications.externalPosts.map(
        (p) => ({ ...p, source: 'manual' as const }) as Post
      ),
    []
  );

  return (
    <>
      <Writing
        blogPosts={blogPosts}
        externalPosts={externalPosts}
        isLive={blogPosts.length > 0}
        loading={loading}
        blogHref={site.links['blog'] ?? '#'}
        copy={writingCopy}
      />
      <Publications outlets={publications.outlets} copy={publicationsCopy} />
      <ContactCTA calendlyHref={site.links['calendly'] ?? '#'} copy={contactCtaCopy} />
    </>
  );
}
